'use client'; // Error components must be Client Components

import { Button, Stack } from '@mui/material';
import { useEffect } from 'react';

export default function Error({
  error,
  reset
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    // Log the error to an error reporting service
    console.error(error);
  }, [error]);

  return (
    <main id='app-body' className='tud-v2 app-body'>
      <div className='signup-page'>
        <div className='theme-container'>
          <div className='signup-page__inner'>
            <div className='signup-page__main'>
              <Stack spacing={4}>
                <h1>{`Error!`}</h1>
                <h2 className='emphasised'>Something went wrong.</h2>
                <Button
                  className='btn-continue'
                  variant='contained'
                  color='primary'
                  disableElevation
                  onClick={() => reset()}
                >
                  Return to Home
                </Button>
              </Stack>
            </div>
          </div>
        </div>
      </div>
    </main>
  );
}
